"use client";

import React from "react";
import { ShieldCheck, Sparkles, Palette } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GuidelinesResources() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const items = [{
    title: "Safe Sharing",
    icon: <ShieldCheck className="size-8 text-chart-2" />,
    points: ["Share only what feels safe for you today.", "You can choose to remain anonymous.", "Take breaks whenever you need them.", "Your emotional safety is the priority."]
  }, {
    title: "Creative Prompts",
    icon: <Sparkles className="size-8 text-chart-2" />,
    points: ["Describe a place where you feel calm.", "What color represents your hope?", "Write a letter to your future self.", "Draw a shape that feels like courage."]
  }, {
    title: "Artistic Tips",
    icon: <Palette className="size-8 text-chart-2" />,
    points: ["Focus on the process, not the result.", "Use colors to express your feelings.", "There is no 'wrong' way to create.", "Let your imagination guide your hand."]
  }];
  return <section id="guidelines-resources" className="relative w-full py-16 md:py-24 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-0 left-1/4 w-[600px] h-[600px] bg-chart-3/10 rounded-full blur-[100px] opacity-60" />
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-chart-2/5 rounded-full blur-[80px] opacity-50" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("bg-card/50 backdrop-blur-sm border border-chart-3/30 rounded-[2rem] shadow-sm transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-chart-3/40">
            {items.map((item, i) => <div key={i} data-index={i} className="p-8 md:p-12 flex flex-col gap-6 hover:bg-white/40 transition-colors duration-500 first:rounded-t-[2rem] md:first:rounded-l-[2rem] md:first:rounded-tr-none last:rounded-b-[2rem] md:last:rounded-r-[2rem] md:last:rounded-bl-none">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-white/80 rounded-2xl shadow-sm ring-1 ring-chart-3/20">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-serif font-semibold text-primary">
                    {item.title}
                  </h3>
                </div>

                <ul className="space-y-3">
                  {item.points.map((point, idx) => <li key={idx} className="flex items-start gap-3 text-muted-foreground">
                      <span className="mt-2 size-1.5 rounded-full bg-chart-3 shrink-0" />
                      <span className="text-sm leading-relaxed font-sans font-medium">
                        {point}
                      </span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}